// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4a451428] .ql-container {\n  height: auto;\n}\n[data-v-4a451428] .ql-container.ql-snow {\n  border: none;\n}\n[data-v-4a451428] .ant-modal-wrap {\n  z-index: 2000;\n}\n[data-v-4a451428] .ant-modal-mask {\n  z-index: 1999;\n}", ""]);
// Exports
module.exports = exports;
